export const getPoints = (pointsCount: number): { value: string, label: string }[] => {
    const points = [];
    for (let i = 1; i <= pointsCount; i++) {
        points.push({
            value: `${i}`,
            label: `${i}`,
        })
    }
    return points;
}